import React from 'react'
import { xinyiAbout } from './content'
import type { Lang } from './types'

interface XinyiAboutSplitV2Props {
  currentLang: Lang
}

/**
 * XinyiAboutSplitV2
 * Asymmetrical image + narrative block — left square image (7 cols),
 * right copy column (5 cols). Mirrors AboutSplitV2 / BusinessIntroV2.
 */
const XinyiAboutSplitV2: React.FC<XinyiAboutSplitV2Props> = ({ currentLang }) => {
  return (
    <section className="bg-[#FAF9F1] py-16 md:py-24">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:items-center md:gap-16">
          {/* Image — left, square */}
          <div className="md:col-span-7">
            <div className="relative aspect-square w-full overflow-hidden">
              <img
                src={xinyiAbout.image}
                alt={xinyiAbout.imageAlt[currentLang]}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
          </div>

          {/* Copy — right */}
          <div className="md:col-span-5">
            <p
              className="mb-5 text-[12px] tracking-[0.22em] text-black/65"
              style={{
                fontFamily: "'EB Garamond', serif",
                fontStyle: 'italic',
                fontWeight: 400,
              }}
            >
              {xinyiAbout.eyebrow[currentLang]}
            </p>

            <h2
              className="mb-4 text-black"
              style={{
                fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                fontWeight: 400,
                fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                letterSpacing: '0.04em',
                lineHeight: 1.25,
              }}
            >
              {xinyiAbout.headline[currentLang]}
            </h2>

            <p
              className="mb-6 text-[15px] tracking-[0.05em] text-black/70"
              style={{
                fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                fontStyle: 'italic',
                fontWeight: 400,
              }}
            >
              {xinyiAbout.quote[currentLang]}
            </p>

            <p
              className="text-[15px] leading-loose text-black/75"
              style={{
                fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
                fontWeight: 300,
                letterSpacing: '0.03em',
              }}
            >
              {xinyiAbout.body[currentLang]}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default XinyiAboutSplitV2
